import React from 'react';
import MobileAdV5HeroSection from '../components/MobileAdV5HeroSection';

const MobileAdV5Page = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <MobileAdV5HeroSection />
    </div>
  );
};

export default MobileAdV5Page;
